import { render, staticRenderFns } from "./innovationBanner.vue?vue&type=template&id=4eea869f&scoped=true&"
import script from "./innovationBanner.vue?vue&type=script&lang=js&"
export * from "./innovationBanner.vue?vue&type=script&lang=js&"
import style1 from "./innovationBanner.vue?vue&type=style&index=1&id=4eea869f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eea869f",
  null
  
)

export default component.exports